module.exports = __webpack_public_path__ + "img/act-of-emotion-inspect-medium.3606c124.jpg";